<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2">A </span><span class="t3">LOS</span><span class="t2"> </span><span class="t3">LECTORES</span><span class="t2"> </span><span class="t3">LES</span><span class="t2"> </span><span class="t3">ENCANTA</span></p>
<p class="p1"><span class="t2">A</span><span class="t3">MY</span><span class="t2"> L</span><span class="t3">ANE</span></p>
<p class="p2"><span class="t4">Manteniendo la Roca Promesa</span></p>
<p><span class="t5">La Roca Promesa</span> probablemente tiene un fallo en algún sitio. Pero estaba demasiado ocupada enamorándome de los personajes como para darme cuenta.</p>
<p>—Rainbow Reviews</p>
<p class="p4">¿Sabes cuándo puedes decir que alguien es un gran autor? Cuando esa persona escribe un libro tan lleno de emociones demoledoras que el lector no puede parar de llorar, ya sean lágrimas de pena o de felicidad. Eso es lo que la autora Amy Lane ha conseguido con <span class="t5">La Roca Promesa</span>.</p>
<p>—Lectura Recomendada de Fallen Angel Reviews</p>
<p class="p4"><span class="t4">Si Debo</span></p>
<p>Esta historia corta es deliciosa, entretenida y profundamente fabulosa.</p>
<p>—Whipped Cream Reviews</p>
<p class="p5"><span class="t3">HTTP</span><span class="t2">://</span><span class="t3">WWW</span><span class="t2">.</span><span class="t3">DREAMSPINNERPRESS</span><span class="t2">.</span><span class="t3">COM</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003.vue?28ddae36